import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import ResourceService from '../../services/resource.service';
import ReferralNav from './referralNav';
import LinkingCode from './linkingCode';
import Assests from './assets';
import Statistics from './statistics';


export default class Referral extends React.Component {

    constructor(props) {
        super(props);
        // loadCss();
        this.state = {
            accNavActive: "",
            isUserSubscribed: false
        };
        this.headerTopRef = React.createRef();
        this.addNavclassOnNavClick = this.addNavclassOnNavClick.bind(this);
    }

    addNavclassOnNavClick(cls) {
        this.setState({
            accNavActive: cls
        });
    }

    checkForSubscription = () => {
        this.setState({ showLoader: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    showLoader: false,
                    message: "Error while getting user subscription details"
                });
                return;
            } else if(resp.error) {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: false,
                });
            } else {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: true,
                });
            }
        });
    };

    componentDidMount() {

        if(localStorage.getItem("roleId") == 1) {
            this.props.history.push("/error");
        }
        this.updateAccClass();
        this.checkForSubscription();

    }

    updateAccClass = () => {
        let geturl = window.location.href;
        let cls = "";
        if(geturl.indexOf("creditcard") !== -1) {
            cls = "acc_creditCardUpdate billing_module_ui billing_cc_wrp";
        } else if(geturl.indexOf("billinghistory") !== -1) {
            cls = "acc_billHistory billing_module_ui billing_history_wrp";
        } else if(geturl.indexOf("myinvoices") !== -1) {
            cls = "acc_myInvoice billing_module_ui billing_invoice_wrp";
        }

    };

    updateHeaderTop() {
        this.headerTopRef.current.updateTopRightHeaderDetails();
    }

    render() {
        return (
            <div className='referral_module_ui'>
                <main>
                    <div className="full_page_loader" style={ { display: this.state.loader ? "block" : "none" } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'referral' }></LeftNav>
                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } ref={ this.headerTopRef } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom accSetting_btm_header">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no">
                                            <span className="text bold_600">Referral Program</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className="main_section">
                            <div className="main_body_container">
                                <ReferralNav addNavclassOnNavClick={ this.addNavclassOnNavClick } />
                                <Switch>
                                    <Route path="/referral/referral_linking_code" ><LinkingCode /></Route>
                                    <Route path="/referral/assests" ><Assests /></Route>
                                    <Route path="/referral/referral_statistics" ><Statistics /></Route>
                                </Switch>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
        );
    }
}

/*function loadCss() {
    const link = document.createElement("link")
    link.href = "https://www.idrivecompute.com/webapp/css/account-module.css"
    //link.href = "http://173.255.13.22/webapp/css/account-module.css"
    //link.href = "/webapp/css/account-module.css"
    link.rel = "stylesheet"
    document.head.appendChild(link)
}*/